module.exports = __webpack_public_path__ + "static/media/yellow-s.32e97390.svg";